import { render } from "./InventoryIndexFilters.vue?vue&type=template&id=0e161b37"
import script from "./InventoryIndexFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryIndexFilters.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Inventory/InventoryIndexFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e161b37"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e161b37', __exports__)) {
    api.reload('0e161b37', __exports__)
  }
  
  module.hot.accept("./InventoryIndexFilters.vue?vue&type=template&id=0e161b37", () => {
    api.rerender('0e161b37', render)
  })

}


export default __exports__